import { useTheme } from '@mui/material';
import { createMakeStyles } from 'tss-react';

const { makeStyles, useStyles } = createMakeStyles({ useTheme });

export default makeStyles;
export { useStyles };
